<script>
import { baseMethods } from '@state/helpers/base.js'
import { getSavedState, removeState } from '@src/utils/localStorage'
import '@src/design/components/error.scss'

export default {
    page: {
        title: 'Erro',
        meta: [{ name: 'description', content: 'error' }],
    },
    props: {
        resource: {
            type: String,
            default: '',
        },
    },
    computed: {
        errorType() {
            return getSavedState(`errorType`)
        },
    },
    mounted() {
        this.setPageTitle(
            this.$t(`Errors["error_${this.errorType || 500}"].title`)
        )
    },
    beforeDestroy() {
        this.setPageTitle('')
    },
    methods: {
        ...baseMethods,
        clickBackButton() {
            // se o usuario fez login e escolheu uma unidade, volta para o mapa de ocupação;
            // senão volta para a tela de login
            const path =
                getSavedState(`auth.token`) &&
                getSavedState(`auth.selectedLocation`)
                    ? `/`
                    : `/login`

            // se o usuario for para a login, remove as variaveis que causam o redirecionamento
            if (path.includes(`login`)) {
                removeState(`auth.token`)
                removeState(`auth.currentUser`)
            }

            this.$router.push(path)
        },
    },
}
</script>

<template>
    <div id="error">
        <b-row class="errorContainer">
            <b-col cols="12" class="errorNumber">
                {{ errorType }}
            </b-col>
            <b-col cols="12" class="errorTitle">
                {{ $t(`Errors["error_${errorType || 500}"].title`) }}
            </b-col>
            <b-col cols="12" class="errorDescription">
                {{ $t(`Errors["error_${errorType || 500}"].description`) }}
            </b-col>
            <b-col>
                <b-button class="button--back" @click.prevent="clickBackButton">
                    {{ $t('Buttons.back') }}
                </b-button>
            </b-col>
        </b-row>

        <b-row>
            <b-col class="errorImg--container">
                <!-- TODO: deixar o campo src dinamico -->
                <img
                    src="@assets/images/svgs/error_404.svg"
                    alt="img"
                    class="errorImg"
                />
            </b-col>
        </b-row>
    </div>
</template>
